import useApiHook from "Hooks/ApiHook";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function DashboardQuotes() {
  /*   All States
   ********************************************* */
  const user = useSelector((state) => state?.user?.userInfo);

  /*   All Functions
   ********************************************* */

  const getDashboardQuotes = async () => {
    const response = await API.get("/dashboard/total-quotes", {
      headers: authHeader(),
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message);
    }
  };

  const {
    data: quotesData,
    loading: quotesLoading,
    error: quotesFetchError,
  } = useApiHook(() => {
    return getDashboardQuotes();
  });

  /*   All UseEffects
   ********************************************* */

  return (
    <div
      className="bg-white px-3 py-2 shadow-sm rounded"
      style={{ width: 600 }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="fw-bold">Quotes</h3>
        {(user?.permissions?.includes("quotes") || user?.roles === "admin") && (
          <Link to="/quotes/pending?page=1" className="btn btn-sm btn-success">
            View
          </Link>
        )}
      </div>
      <hr className="mt-0 mb-2" />
      {quotesLoading || quotesData === null ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner variant="primary" />
        </div>
      ) : quotesFetchError ? (
        <div className="d-flex flex-column justify-content-center align-items-center h-75">
          <h4 className="text-danger text-center">Error</h4>
          <p className="text-center">{quotesFetchError}</p>
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-8 fw-bold">Total Quotes</div>
            <div className="col-4 text-end">
              {quotesData?.totalQuotes || "-"}
            </div>
          </div>
          <div className="row">
            <div className="col-8 fw-bold">With No Location</div>
            <div className="col-4 text-end">
              {quotesData?.withoutLocation || "-"}
            </div>
          </div>
          <div className="d-flex justify-content-between gap-5 align-items-start mt-2">
            <div className="w-50">
              <h4
                className="border-1 pe-2 fw-bold border-bottom "
                style={{ width: "fit-content" }}
              >
                By Location
              </h4>
              {Object.keys(quotesData?.byLocation).length &&
                Object.keys(quotesData?.byLocation).map((key) => (
                  <div className="row">
                    <div className="col-8 fw-bold">{key}</div>
                    <div className="col-4 text-end">
                      {quotesData?.byLocation[key]}
                    </div>
                  </div>
                ))}
            </div>
            <div className="w-50">
              <h4
                className="border-1 pe-2 fw-bold border-bottom "
                style={{ width: "fit-content" }}
              >
                By Status
              </h4>
              {Object.keys(quotesData?.byStatus).length &&
                Object.keys(quotesData?.byStatus).map((key) => (
                  <div className="row">
                    <div className="col-8 fw-bold">{key}</div>
                    <div className="col-4 text-end">
                      {quotesData?.byStatus[key]}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
